export const firebaseConfig = {
    apiKey: "AIzaSyBGoYg3NeSobR5mBPkzWdT4Q2iz1hAt05M",
    authDomain: "vhack-usm.firebaseapp.com",
    projectId: "vhack-usm",
    storageBucket: "vhack-usm.appspot.com",
    messagingSenderId: "1020778204734",
    appId: "1:1020778204734:web:58560eb66201daa5430b6f",
    measurementId: "G-DT1CW3C1K3"
};
